/**
 * Created by andrey on 12.03.2025
 */

const KpiLogger = function () {
    this.load();

    this.initChannels();

    cleverapps.whenAllInitialized(this.init.bind(this));
};

KpiLogger.prototype.initChannels = function () {
    this.addChannel("");
    cleverapps.country.whenReady((country) => {
        this.setChannel("us", country === "US");
    });
};

KpiLogger.prototype.init = function () {
    if (connector.platform.oneOf(connector.ANDROID, connector.AMAZON, connector.IOS)) {
        connector.platform.on("attributionChanged", (attribution) => this.onAttributionChanged(attribution));
        connector.platform.parsePayload((attribution) => {
            if (attribution) {
                this.onAttributionChanged(attribution);
            }
        });
        return;
    }

    let channel = cleverapps.user.channel || "";
    if (connector.platform.oneOf(connector.INSTANT) && !cleverapps.isNumber(channel)) {
        channel = "";
    }
    this.onAttributionChanged({ channel });
};

KpiLogger.prototype.onAttributionChanged = function (attribution) {
    console.log("KpiLogger.onAttributionChanged - ", JSON.stringify(attribution));

    attribution = attribution || {};
    const channel = attribution.channel || attribution.campaign || "";
    const network = (attribution.network || "").toLowerCase();

    if (!channel && !network) {
        this.setOrganic();
    } else {
        this.setPaid();
    }

    KpiLogger.AD_NETWORKS
        .filter((adNetwork) => network.includes(adNetwork) || channel.toLowerCase().includes(adNetwork))
        .forEach((adNetwork) => this.addChannel(adNetwork));

    if (cleverapps.user.isFirstSession()) {
        cleverapps.country.whenReady(() => this.logInstall());
    }
};

KpiLogger.prototype.load = function () {
    this.data = cleverapps.dataLoader.load(DataLoader.TYPES.KPI_LOGGER) || {};
    this.data.channels = this.data.channels || {};
};

KpiLogger.prototype.save = function () {
    cleverapps.dataLoader.save(DataLoader.TYPES.KPI_LOGGER, this.data);
};

KpiLogger.prototype.setPaid = function () {
    this.addChannel("paid");
    this.removeChannel("organic");
};

KpiLogger.prototype.setOrganic = function () {
    this.data.channels = {};

    this.initChannels();
    this.addChannel("organic");
};

KpiLogger.prototype.setChannel = function (channel, value) {
    if (value) {
        this.addChannel(channel);
    } else {
        this.removeChannel(channel);
    }
};

KpiLogger.prototype.addChannel = function (channel) {
    if (!this.data.channels[channel]) {
        this.data.channels[channel] = 1;
        this.save();
    }
};

KpiLogger.prototype.removeChannel = function (channel) {
    if (this.data.channels[channel]) {
        delete this.data.channels[channel];
        this.save();
    }
};

KpiLogger.prototype.logPurchase = function (value) {
    this.logConversionKpi("payments", { value });
};

KpiLogger.prototype.logAdRevenue = function (value) {
    this.logConversionKpi("ads", { value });
};

KpiLogger.prototype.logInstall = cleverapps.once(function () {
    this.logKpi("installs", { value: 1 });
});

KpiLogger.prototype.logConversionKpi = function (name, params) {
    const conversionWindow = this.getConversionWindow();
    if (conversionWindow === -1) {
        return;
    }

    this.logKpi(`${name}_d${conversionWindow}`, params);
};

KpiLogger.prototype.logKpi = function (name, params) {
    if (cleverapps.flags && cleverapps.flags.noLogEvents) {
        return;
    }

    // a cheater (cleverapps.user.cheater) adds nothing to the channel KPI: its ad revenue would count towards ROAS of the channel that sold it
    if (cleverapps.user.cheater) {
        return;
    }
    
    const event = this.getUserRegisteredMonth();
    for (const channel in this.data.channels) {
        cleverapps.metrics.logEvent(`kpi_${name}`, {
            value: params.value,
            event,
            channel,
            accumulate: params.accumulate,
            channelMetrics: true
        });
    }
};

KpiLogger.prototype.getUserRegisteredMonth = function () {
    const date = new Date(cleverapps.user.registered);
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
    return date.getTime();
};

KpiLogger.prototype.getConversionWindow = function () {
    const days = cleverapps.user.getDaysSinceRegistration();

    const conversionWindow = KpiLogger.CONVERSION_WINDOWS.find((conversionWindow) => days <= conversionWindow);

    return conversionWindow !== undefined ? conversionWindow : -1;
};

KpiLogger.CONVERSION_WINDOWS = cleverapps.arrayFill(90, 0).map((item, index) => index).concat([120, 150, 180, 210, 240, 270, 300, 330, 364]);

KpiLogger.AD_NETWORKS = ["bing", "vungle", "applovin", "google", "tyrads", "unity", "maf", "mintegral", "apple"];